import { Action } from "redux";
import { IDataQueueResponse, IWorkflowItem, IWorkflowItemStep } from "../../../common/sharedTypes";

export interface IDataTranscribeQueueState {
  workflowItemSteps: IDataQueueResponse[];
  openWorkflowItemStep: IDataQueueResponse;
  loadingWorkflowSteps: boolean;
  totalWorkflowItemSteps: number;
}

// ACTIONS
export interface IDataTranscribeQueueAction extends Action {
  type: "@@dataentryqueue/GET_DATA_ENTRY_QUEUE_REPORTS";
  payload: {};
}

export enum DataTranscribeQueueActionTypes {
  SEARCH_REPORTS = "@@datatranscribe/GET_DATA_ENTRY_QUEUE_REPORTS",
  OPEN_REPORT = "@@datatranscribe/OPEN_REPORT",
  ASSIGN_AND_OPEN_REPORT = "@@datatranscribe/ASSIGN_AND_OPEN_REPORT",
  UNASSIGN = "@@datatranscribe/UNASSIGN",
  COMPLETE_DATA_ENTRY = "@@datatranscribe/COMPLETE_DATA_ENTRY",
  LOADING_WORKFLOW_STEPS = "@@datatranscribe/LOADING_WORKFLOW_STEPS",
  TOTAL_WORKFLOW_STEPS = "@@datatranscribe/TOTAL_WORKFLOW_STEPS",
}

export type QNotificationActions = IDataTranscribeQueueAction;
